import { HomeActionType, HomeState, ReportSearchState } from '~/actions/home-actions';

export const DEFAULT_REPORT_SEARCH_STATE: ReportSearchState = {
  forthcomingSearchOptions: {},
};

export const reportSearchReducer = (state: HomeState, action: any): Partial<HomeState> => {
  switch (action.type) {
    case HomeActionType.FilterReportListPending:
      return {
        reportSearch: {
          ...state.reportSearch,
          forthcomingSearchOptions: action.meta.options, // save forthcoming search options for dirty checking, see {@link HomeReducer.getReportList()}
        },
      };
    default:
      return {};
  }
};
